import { render } from "./attendee.self.service.email.vue?vue&type=template&id=4bd8b164"
import script from "./attendee.self.service.email.vue?vue&type=script&lang=js"
export * from "./attendee.self.service.email.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__